import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends PureComponent<any> {
  componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      toTop();
    }
  }

  render() {
    return <span>{this.props.children}</span>;
  }
}

export const toTop = () => window.scrollTo(0, 0);

export default withRouter(ScrollToTop);
